import { createServerFn } from '@tanstack/react-start';
import axios from 'axios';
import _ from 'lodash';
import { z } from 'zod';
import config from '#/config';

const CalendlyInviteeSchema = z.object({
  uri: z.string(),
});

export const getCalendlyInvitee = createServerFn({
  method: 'POST',
})
  .validator(
    (data: {
      uri: string;
    }) => {
      const result = CalendlyInviteeSchema.parse(data);
      return _.chain(result.uri)
        .replace('https://api.calendly.com/scheduled_events/', '')
        .split('/invitees/')
        .thru((parts) => ({
          eventId: parts[0],
          inviteeId: parts[1],
        }))
        .value();
    }
  )
  .handler(async (ctx) => {
    console.log('Fetching invitee', ctx.data);
    const result = await axios.get(
      `https://api.calendly.com/scheduled_events/${ctx.data.eventId}/invitees/${ctx.data.inviteeId}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${config.calendly.apiKey}`,
        },
      }
    );
    const inviteeResult = result.data as CalendlyInviteeResult;

    return {
      email: inviteeResult.resource.email,
    };
  });

type CalendlyInviteeResult = {
  resource: {
    cancel_url: string;
    created_at: string;
    email: string;
    event: string;
    first_name: string | null;
    invitee_scheduled_by: string | null;
    last_name: string | null;
    name: string;
    new_invitee: string | null;
    no_show: string | null;
    old_invitee: string | null;
    payment: string | null;
    questions_and_answers: Array<{
      question: string;
      answer: string;
    }>;
    reconfirmation: string | null;
    reschedule_url: string;
    rescheduled: boolean;
    routing_form_submission: string | null;
    scheduling_method: string | null;
    status: string;
    text_reminder_number: string | null;
    timezone: string;
    tracking: {
      utm_campaign: string | null;
      utm_source: string | null;
      utm_medium: string | null;
      utm_content: string | null;
      utm_term: string | null;
      salesforce_uuid: string | null;
    };
    updated_at: string;
    uri: string;
  };
};
